import React, { Component, useEffect, useState } from 'react'
import Breadcrumbs from '../components/Breadcrumbs';
import TopFilter from '../components/TopFilter';
import TopProviderByBillCount from '../components/charts/TopProviderByBillCount';
import TopProviderByBillType from '../components/charts/TopProviderByBillType';
import MonthWiseBillsByBillType from '../components/charts/MonthWiseBillsByBillType';
import TopCustomersByCharacterCount from '../components/charts/TopCustomersByCharacterCount';
import TopProviderByPageCount from '../components/charts/TopProviderByPageCount';
import TopProviderByCharacterCount from '../components/charts/TopProviderByCharacterCount';
import configData from '../configData.json';
import LeftMenu from '../components/LeftMenu';
import TopBar from '../components/TopBar';
import Footer from '../components/Footer';
import moment from 'moment';
import { useRef } from 'react';

export default function HomePage() {

    const [toDate, setToDate] = useState(new Date());
    // const [fromDate, setFromDate] = useState(new Date(toDate.getFullYear(), 0, 1, 23, 59, 59));
    const [fromDate, setFromDate] = useState(new Date(toDate.getFullYear(), 0, 1, 23, 59, 59));
    const [startDate, setStartDate] = useState(moment(fromDate).format().substring(0, 10));
    const [endDate, setEndDate] = useState(moment(toDate).format().substring(0, 10));

    const pageCount = 5;

    // const [custkey, setCustkey] = useState(0);

    const [topProvidersByBillCount, setTopProvidersByBillCount] = useState([]);
    const [topProvidersByPageCount, setTopProvidersByPageCount] = useState([]);
    const [topProvidersByCharacterCount, setTopProvidersByCharacterCount] = useState([]);
    const [topProvidersByBillType, setTopProvidersByBillType] = useState([]);
    const [monthWiseBillsByBillType, setMonthWiseBillsByBillType] = useState([]);
    const [topCustomersByCharacterCount, setTopCustomersByCharacterCount] = useState([]);

    const [loadingTopProvidersByBillCount, setLoadingTopProvidersByBillCount] = useState(false);
    const [loadingTopProvidersByPageCount, setLoadingTopProvidersByPageCount] = useState(false);
    const [loadingTopProvidersByCharacterCount, setLoadingTopProvidersByCharacterCount] = useState(false);
    const [loadingTopProvidersByBillType, setLoadingTopProvidersByBillType] = useState(false);
    const [loadingMonthWiseBillsByBillType, setLoadingMonthWiseBillsByBillType] = useState(false);
    const [loadingTopCustomersByCharacterCount, setLoadingTopCustomersByCharacterCount] = useState(false);

    const criData = [
        { criKey: 1, criValue: 'Customer' }
    ];

    const LoadTopProviderByBillCount = async (startDate, endDate, custkey, ownerId) => {
        // debugger;
        try {
            setLoadingTopProvidersByBillCount(true);
            // const url = `${configData.BASE_APP_URL}Dashboard/GetTopTransportationProviderByBillCount/${startDate}/${endDate}/${pageCount}`;
            const url = `${configData.BASE_APP_URL}Dashboard/GetTopTransportationProviderByBillCount/${startDate}/${endDate}/${pageCount}/${custkey}/${ownerId}`;
            await fetch(url,
                {
                    method: 'GET',
                    headers: {
                        'Content-type': 'application/json',
                        'Authorization': sessionStorage.getItem('my-token')
                    }
                }
            ).then(resp => resp.json())
                .then(resp => setTopProvidersByBillCount(resp))
            setLoadingTopProvidersByBillCount(false);
        }
        catch (error) {
            setLoadingTopProvidersByBillCount(false);
        }
    }

    const LoadTopProviderByPageCount = async (startDate, endDate,custkey, ownerId) => {
        try {
            setLoadingTopProvidersByPageCount(true);
            const url = `${configData.BASE_APP_URL}Dashboard/GetTopTransportationProviderByAveragePageCount/${startDate}/${endDate}/${pageCount}/${custkey}/${ownerId}`;
            await fetch(url,
                {
                    method: 'GET',
                    headers: {
                        'Content-type': 'application/json',
                        'Authorization': sessionStorage.getItem('my-token')
                    }
                }
            ).then(resp => resp.json())
                .then(resp => setTopProvidersByPageCount(resp))
            setLoadingTopProvidersByPageCount(false);
        }
        catch (error) {
            setLoadingTopProvidersByPageCount(false);
        }

    }

    const LoadTopProviderByCharacterCount = async (startDate, endDate,custkey,ownerId) => {
        // debugger;
        try {
            setLoadingTopProvidersByCharacterCount(true);
            const url = `${configData.BASE_APP_URL}Dashboard/GetAverageCharacterCountByServiceType/${startDate}/${endDate}/${custkey}/${ownerId}`;
            await fetch(url,
                {
                    method: 'GET',
                    headers: {
                        'Content-type': 'application/json',
                        'Authorization': sessionStorage.getItem('my-token')
                    }
                }
            ).then(resp => resp.json())
                .then(resp => setTopProvidersByCharacterCount(resp))
            setLoadingTopProvidersByCharacterCount(false);
        }
        catch (error) {
            setLoadingTopProvidersByCharacterCount(false);
        }

    }

    const LoadTopProviderByBillType = async (startDate, endDate,custkey,ownerId) => {
        try {
            setLoadingTopProvidersByBillType(true);
            const url = `${configData.BASE_APP_URL}Dashboard/GetTopTransportationProviderByBillType/${startDate}/${endDate}/${pageCount}/${custkey}/${ownerId}`;
            await fetch(url,
                {
                    method: 'GET',
                    headers: {
                        'Content-type': 'application/json',
                        'Authorization': sessionStorage.getItem('my-token')
                    }
                }
            ).then(resp => resp.json())
                .then(resp => setTopProvidersByBillType(resp))
            setLoadingTopProvidersByBillType(false);
        }
        catch (error) {
            setLoadingTopProvidersByBillType(false);
        }
    }

    const LoadMonthWiseBillsByBillType = async (startDate, endDate,custkey,ownerId) => {
        try {
            setLoadingMonthWiseBillsByBillType(true);
            const url = `${configData.BASE_APP_URL}Dashboard/GetMonthlyBillsByBillType/${startDate}/${endDate}/${custkey}/${ownerId}`;
            await fetch(url,
                {
                    method: 'GET',
                    headers: {
                        'Content-type': 'application/json',
                        'Authorization': sessionStorage.getItem('my-token')
                    }
                }
            ).then(resp => resp.json())
                .then(resp => setMonthWiseBillsByBillType(resp))
            setLoadingMonthWiseBillsByBillType(false);
        }
        catch (error) {
            setLoadingMonthWiseBillsByBillType(false);
        }

    }

    const LoadTopCustomersByCharacterCount = async (startDate, endDate,custkey,ownerId) => {
        try {
            setLoadingTopCustomersByCharacterCount(true);
            const url = `${configData.BASE_APP_URL}Dashboard/GetTopCustomersByCharacterCount/${startDate}/${endDate}/${pageCount}/${custkey}/${ownerId}`;
            await fetch(url,
                {
                    method: 'GET',
                    headers: {
                        'Content-type': 'application/json',
                        'Authorization': sessionStorage.getItem('my-token')
                    }
                }
            ).then(resp => resp.json())
                .then(resp => setTopCustomersByCharacterCount(resp))
            setLoadingTopCustomersByCharacterCount(false);
        }
        catch (error) {
            setLoadingTopCustomersByCharacterCount(false);
        }
    }

    useEffect(() => {
        console.log(fromDate);
        console.log(startDate);
        LoadTopProviderByBillCount(startDate, endDate, 0, 0);
        LoadTopProviderByPageCount(startDate, endDate, 0, 0);
        LoadTopProviderByCharacterCount(startDate, endDate, 0, 0);
        LoadTopProviderByBillType(startDate, endDate, 0, 0);
        LoadMonthWiseBillsByBillType(startDate, endDate, 0, 0);
        LoadTopCustomersByCharacterCount(startDate, endDate, 0, 0);
    }, [])


    const onCustomerChangeFilter = (selectedOwner, selectedCust, selectedCarrier, selectedFromDate, selectedToDate, fbNum, acctNo) => {
        // debugger;
       console.log(selectedCust);
    //    setCustkey(selectedCust);
       LoadTopProviderByBillCount(selectedFromDate, selectedToDate, selectedCust, selectedOwner);
       LoadTopProviderByPageCount(selectedFromDate, selectedToDate,selectedCust, selectedOwner);
       LoadTopProviderByCharacterCount(selectedFromDate, selectedToDate,selectedCust, selectedOwner);
       LoadTopProviderByBillType(selectedFromDate, selectedToDate,selectedCust, selectedOwner);
       LoadMonthWiseBillsByBillType(selectedFromDate, selectedToDate,selectedCust, selectedOwner);
       LoadTopCustomersByCharacterCount(selectedFromDate, selectedToDate,selectedCust, selectedOwner);
    };

    const RenderCharts = ({ loading }) => {
        return (
            <div className='row d-flex  chart-container'>
                <TopProviderByBillCount data={topProvidersByBillCount} loading={loading} />
                <TopProviderByPageCount data={topProvidersByPageCount} loading={loading} />
                <TopProviderByCharacterCount data={topProvidersByCharacterCount} loading={loading} />
                <TopProviderByBillType data={topProvidersByBillType} loading={loading} />
                <MonthWiseBillsByBillType data={monthWiseBillsByBillType} loading={loading} />
                <TopCustomersByCharacterCount data={topCustomersByCharacterCount} loading={loading} />
            </div>
        )
    }

    const Charts = () => {

        let isLoading = false

        // if (loadingTopProvidersByBillCount
        //     || loadingTopProvidersByPageCount
        //     || loadingTopProvidersByBillType
        //     || loadingTopProvidersByCharacterCount
        //     || loadingMonthWiseBillsByBillType
        //     || loadingTopCustomersByCharacterCount) {
        //     isLoading = true
        if (loadingTopProvidersByBillCount
            || loadingTopProvidersByPageCount
            || loadingTopProvidersByBillType
            || loadingTopProvidersByCharacterCount
            || loadingMonthWiseBillsByBillType
            ) {
            isLoading = true
        }

        if (isLoading) {
            return <RenderCharts loading={true} />
        }

        return <RenderCharts loading={false} />
    }

    

    return (
        <>
            <div className='st1'>
                <LeftMenu />
                <div className="mcw">
                    <TopBar />
                    <div className='pt-1 px-3 pb-3 py-3'>
                        <Breadcrumbs title="Dashboard" />
                        <div className='sticky-top-content' style={{position:'relative', zIndex:10}}>
                            <TopFilter oncustom={onCustomerChangeFilter} criData={criData} isAddFilterHidden={true}  />
                        </div>
                        <Charts />
                    </div>
                    <Footer />
                </div>
            </div>
        </>

    )
}

